<template>
    <v-container>
        <v-layout>
            <v-flex class="hideInMobile">
                <student-info style="background-color: white; margin-bottom: 5px"/>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-tabs background-color="deep-purple"
                        left
                        next-icon="mdi-arrow-right-bold-box-outline"
                        prev-icon="mdi-arrow-left-bold-box-outline"
                        show-arrows
                        dark
                        v-model="activeTab"
                >
                    <v-tabs-slider color="#00ab4d"></v-tabs-slider>
                    <v-tab key="myclass" @click="refreshTabAll" style="width: 150px">
                        Lớp học
                    </v-tab>
                    <v-tab flat color="#00ab4d" key="account" @click="refreshTabAll" style="width: 150px">
                        Tài khoản
                    </v-tab>
                    <v-tab-item key="myclass">
                        <my-class-component/>
                    </v-tab-item>
                    <v-tab-item key="account" style="background-color: white">
                        <Profile style="width: 100%"/>
                    </v-tab-item>

                </v-tabs>

            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import StudentInfo from "../class/studentProfile";
    import MyClassComponent from "./MyClassComponent";
    import Profile from "../Profile";

    export default {
        components: {Profile, MyClassComponent, StudentInfo, TeacherInfo, ClazzCreate},
        data() {
            return {
                lstClass: []
            }
        },
        created() {
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
                if(mutation.type == "common/setSearch"){
                    this.search = mutation.payload;
                    this.searchClass();
                }
            });
            this.searchClass();

        },
        beforeDestroy() {
            this.unsubscribe();
        },
        methods: {
            joinClass: function () {
                this.$router.push("/joinClass");
            },

            viewClass: function (clss) {
                this.$router.push("ViewClass/"+clss.classId);
            },

            searchClass:function(){
                let url = process.env.VUE_APP_API_URL + "/class/myclass?";
                if(this.search != null && this.search != ""){
                    url +="search="+this.search;
                }
                axios.post(url).then(
                    data => {
                        this.lstClass = data;
                    },
                    error => {
                        console.log(error);
                    }
                )
            },

            getClassAvatar:function(attachId){
                let link = "/img/yoclass/logo_green.png";
                if(attachId == null || attachId == ""|| attachId == undefined){

                } else {
                    link  = process.env.VUE_APP_API_URL + "/download/attach/"+attachId;
                }
                return link;

            },

        }
    };
</script>